import { motion, AnimatePresence } from "framer-motion";

const Card = ({image, title, year,}) => {

    return(
            <div className='w-[80%] md:w-fit relative flex p-10 px-18 mx-7 cursor-pointer mt-2 shrink-0 justify-center items-center flex-col gap-4 border-0 carde'>
                <div className='w-full absolute bg-black/[0.30]  h-full rounded-[25px] mix-blend-overlay border-[3px] border-solid border-white'></div>
                <div className='w-full absolute h-full rounded-[25px] mix-blend-overlay border-solid border-white border-[2px]'></div>
                <AnimatePresence>
                    <motion.div 
                    key="card"
                    initial={{opacity:0, x:-10}}
                    animate={{opacity:1, x:0}}
                    exit={{opacity:0}}
                    whileHover={{scale:1.03, transition:{duration:0.2}}}
                    transition={{duration:0.8, ease:"easeInOut"}} 
                    className='relative flex flex-col justify-center items-center gap-4'>  
                        <img className= 'w-[3em] md: noselect w-[6em]'  src={image} alt='' ></img>
                        <div className='flex flex-col justify-center items-center gap-1'>
                            <p className="text-lg text-white">{title}</p>
                            <p className="text-xs text-slate-400">{year}</p>
                        </div>
                    </motion.div>
                </AnimatePresence>
                    
                </div>

    )
}

export default Card;